import { useEffect, useState } from 'react'
import './ChristmasGifts.css'
import { authedGet, authedPost } from '../lib/intranet_tools_service'
import { EditModal } from './EditModal'
import { ChristmasGift, NewChristmasGift } from './types'
import { GIFTS, INVOICE_STATUSES, ORDER_STATUSES, reverseDate } from './util'
import { NewModal } from './NewModal'

const DEFAULT_GIFT: NewChristmasGift = {
  FirstName: '',
  LastName: '',
  Email: '',
  Token: '',
}

export const ChristmasGifts = () => {
  const [christmasGifts, setChristmasGifts] = useState<ChristmasGift[]>()
  const [selected, setSelected] = useState<ChristmasGift | undefined>()
  const [newGift, setNewGift] = useState<NewChristmasGift | undefined>()
  const [error, setError] = useState('')

  const loadChristmasGifts = async () => {
    const result = await authedGet('christmas-gifts')
    if (!result.ok) {
      const json = await result.json()
      setError('Error updating: ' + json.error)
    } else {
      const json = (await result.json()) as ChristmasGift[]
      setError('')
      setChristmasGifts(json)
    }
  }

  useEffect(() => {
    loadChristmasGifts()
  }, [])

  const onClickRow = (gift: ChristmasGift) => {
    setSelected({
      ...gift,
      Comment: gift.Comment || '',
      Gift: gift.Gift || GIFTS[0],
      StatusOrderInt: gift.StatusOrderInt || ORDER_STATUSES[0].value,
      StatusOrder: gift.StatusOrder || ORDER_STATUSES[0].label,
      StatusInvoice: gift.StatusInvoice || INVOICE_STATUSES[0],
    })
  }

  const onSave = async (gift: ChristmasGift) => {
    gift.StatusOrder = ORDER_STATUSES.find(
      (os) => os.value === gift.StatusOrderInt
    )!.label
    const result = await authedPost(
      `christmas-gifts/${gift.ID}`,
      JSON.stringify(gift)
    )
    if (!result.ok) {
      const json = await result.json()
      setError('Error updating: ' + json.error)
    } else {
      const json = (await result.json()) as ChristmasGift[]
      setChristmasGifts(json)
      setError('')
      setSelected(undefined)
    }
  }

  const onCreate = async (gift: NewChristmasGift) => {
    const result = await authedPost(`christmas-gifts`, JSON.stringify(gift))
    if (!result.ok) {
      const json = await result.json()
      setError('Error creating: ' + json.error)
    } else {
      const json = (await result.json()) as ChristmasGift[]
      setChristmasGifts(json)
      setError('')
      setNewGift(undefined)
    }
  }

  const WIDTHS = [50, 150, 150, 250, 200, 120, 170, 170, 370]

  return (
    <>
      {newGift && (
        <NewModal
          onClose={() => setNewGift(undefined)}
          newGift={newGift}
          setNewGift={setNewGift}
          onSave={onCreate}
        />
      )}
      {selected && (
        <EditModal
          onClose={() => setSelected(undefined)}
          selected={selected}
          setSelected={setSelected}
          onSave={onSave}
        />
      )}
      <div className="christmas-gifts-container">
        <div className="christmas-gifts-title">
          <div className="flex flex-justify-between">
            <div>Christmas Gifts Overview</div>
            <button
              className="cg-button"
              onClick={() => setNewGift(DEFAULT_GIFT)}
            >
              New
            </button>
          </div>
        </div>
        {error && <div>{error}</div>}
        <div className="table">
          <div className="flex table-row pm-table-header">
            <div style={{ width: WIDTHS[0] }}>ID</div>
            <div style={{ width: WIDTHS[1] }}>First Name</div>
            <div style={{ width: WIDTHS[2] }}>Last Name</div>
            <div style={{ width: WIDTHS[3] }}>E-mail</div>
            <div style={{ width: WIDTHS[4] }}>Gift</div>
            <div style={{ width: WIDTHS[5] }}>Responded on</div>
            <div style={{ width: WIDTHS[6] }}>Status</div>
            <div style={{ width: WIDTHS[7] }}>Invoice status</div>
            <div style={{ width: WIDTHS[8] }}>Comment</div>
          </div>
          {christmasGifts &&
            christmasGifts.map((gift) => (
              <div
                key={gift.ID}
                className="flex pm-table-row"
                onClick={() => onClickRow({ ...gift })}
              >
                <div style={{ width: WIDTHS[0] }}>{gift.ID}</div>
                <div style={{ width: WIDTHS[1] }}>{gift.FirstName}</div>
                <div style={{ width: WIDTHS[2] }}>{gift.LastName}</div>
                <div style={{ width: WIDTHS[3] }}>{gift.Email}</div>
                <div style={{ width: WIDTHS[4] }}>{gift.Gift}</div>
                <div style={{ width: WIDTHS[5] }}>
                  {reverseDate(gift.DateResponded)}
                </div>
                <div style={{ width: WIDTHS[6] }}>{gift.StatusOrder}</div>
                <div style={{ width: WIDTHS[7] }}>{gift.StatusInvoice}</div>
                <div style={{ width: WIDTHS[8] }}>{gift.Comment}</div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}
